import Vue from 'vue'
import Vuex from 'vuex'
import dashboard from './dashboard'
import media from './media'
import adspot from './adspot'
import supplier from './supplier'
import adspotSupplier from './adspot-supplier'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    dashboard,
    media,
    adspot,
    supplier,
    adspotSupplier
  },

  state: {
    userName: ''
  },

  mutations: {
    setUserName (state, payload) {
      state.userName = payload.userName
    }
  }
})
